import React, { ReactElement } from 'react';
import type { CardProps } from '../Customers';
import styles from './Card.module.scss';

import { PhoneIcon } from '../../Icons/PhoneIcon';
import { CircleIcon } from '../../Icons/CircleIcon';
import { ElementIcon } from '../../Icons/ElementIcon';
import { EmojiIcon } from '../../Icons/EmojiIcon';
import { SecurityIcon } from '../../Icons/SecurityIcon';
import { StarIcon } from '../../Icons/StarIcon';
import { WalletIcon } from '../../Icons/WalletIcon';

export type IconProps = {
    [key: string]: ReactElement | null;
};

const icons: IconProps = Object.freeze({
    circle: <CircleIcon />,
    element: <ElementIcon />,
    phone: <PhoneIcon />,
    emoji: <EmojiIcon />,
    security: <SecurityIcon />,
    star: <StarIcon />,
    wallet: <WalletIcon />,
});

interface Props {
    card: CardProps;
}

export const Card: React.FC<Props> = ({ card }) => {
    return (
        <div className={styles.container}>
            <div
                className={styles.backgroundColor}
                style={{ background: card.backgroundColor }}
            />
            <div>
                {icons[card.icon]}
                <div className={styles.title}>{card.title}</div>
            </div>
            <ul>
                {card.rows.map((row, idx) => {
                    return (
                        <li key={idx} className={styles.row}>
                            {row}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};
